// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__3oaTJ","content":"LayoutSettings_content__3-xFo"};